export default (containerId, checked) => {
  const container = document.getElementById(containerId);
  const elements = container.getElementsByTagName('input');

  for (const item of elements) {
    if (item.type === 'checkbox') {
      item.checked = checked;
    }
  }
};



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/utils/toggleCheckBoxes.js